/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createMessage = /* GraphQL */ `
  mutation CreateMessage($content: String!, $sendTo: String!) {
    createMessage(content: $content, sendTo: $sendTo) {
      messageId
      content
      sendTo
      createdAt
      handle
    }
  }
`;
